export default __webpack_public_path__ + "static/media/RABBIT.7c6384bb.svg";